import React from 'react';
import { CTAButton } from './CTAButton';
import { PriceBlock } from './PriceBlock';
export function FinalCta() {
  return <section className="bg-sand py-14 sm:py-20" data-id="element-87" data-mp="vghhfpe10dp0">
      <div className="mx-auto max-w-2xl px-5 text-center" data-id="element-88" data-mp="19ez3lioa9i4t">
        <p className="font-sans text-[0.64rem] font-bold uppercase tracking-editorial text-gold-deep" data-id="element-89" data-mp="19gih51ik1f2w">
          Último paso
        </p>
        <h2 className="mt-3 font-display text-[1.4rem] font-bold uppercase leading-tight text-charcoal sm:text-[2.1rem]" data-id="element-90" data-mp="1jd535tmmac6i">
          Tu conocimiento ya tiene valor.
          <span className="mt-1 block text-gold-deep" data-id="element-91" data-mp="1edimtbbhsfth">Ahora hacé que más personas lo vean.</span>
        </h2>
        <p className="mx-auto mt-4 max-w-xl font-sans text-[0.9rem] leading-relaxed text-charcoal/75 sm:text-base" data-id="element-92" data-mp="1t256tqc2dvr1">
          Ya invertiste tiempo en aprender lo que sabés. Ahora necesitás que las personas correctas
          puedan verlo, entenderlo y elegirte.
        </p>
        <p className="mx-auto mt-2.5 max-w-xl font-sans text-[0.9rem] leading-relaxed text-charcoal/75 sm:text-base" data-id="element-93" data-mp="1x5unltmhz91i">
          Dejá de depender de publicaciones improvisadas y empezá a construir una presencia digital
          diseñada para convertir tu conocimiento en clientes.
        </p>

        <PriceBlock className="mt-6" size="lg" data-id="element-94" data-mp="x2z8g2shtky3" />

        <div className="mt-5 flex justify-center" data-id="element-95" data-mp="122vcu353ree6">
          <CTAButton className="w-full max-w-[26rem] px-4 py-4" data-id="element-96" data-mp="123mvyehijjnk" />
        </div>

        <p className="mt-3 font-sans text-[0.7rem] font-semibold uppercase tracking-[0.14em] text-charcoal/65" data-id="element-97" data-mp="1658g8kwdn07s">
          Coach Digital PRO · Mega Pack 6 en 1
        </p>
        <p className="mt-1 font-sans text-[0.72rem] text-charcoal/55" data-id="element-98" data-mp="1fu9uo6n9x9jn">
          Pago seguro · Garantía 7 días
        </p>
      </div>
    </section>;
}